import { STATUS_OPTIONS, renderStatusIcon } from "./cellRenderers";

export { STATUS_OPTIONS, renderStatusIcon };
export const getColumnStartIconRenderer = (columnName, customRenderer) => {
  if (columnName === "status") {
    return (value) => {
      const config = STATUS_OPTIONS[value];
      return config ? renderStatusIcon(config.icon, config.color) : null;
    };
  }
  return customRenderer;
};
